import React from 'react';
import { TileHead } from '../TileHead';
import { IDS } from '../../../../automationTestIds';

const BOSSOutOfStock = () => {
  return (
    <>
      <div className="u__center">
        <TileHead
          title="Ship to Store"
          icon="pick-up-true"
          automationId={IDS.LABEL.stsLabel}
        />
        <div className="fulfillment__sub-title">
          Out of stock
        </div>
      </div>
    </>
  );
};

BOSSOutOfStock.propTypes = {
};

BOSSOutOfStock.defaultProps = {
};

export { BOSSOutOfStock };
